import styled from 'styled-components';

export default styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;

  & > span {
    font-size: 2.4rem;
  }

  &:hover {
    text-decoration: underline:
  }
`;
